module.exports = __webpack_public_path__ + "static/media/amaris-logo.89e7a41b.jpeg";